// extracted by mini-css-extract-plugin
export var Layout = "Layout-module--Layout--194cl";
export var Layout__main = "Layout-module--Layout__main--3WQkn";
export var Main = "Layout-module--Main--21nxR";